import { render } from "./LookupColumnFiltersView.vue?vue&type=template&id=2c904b2b&ts=true"
import script from "./LookupColumnFiltersView.vue?vue&type=script&lang=ts"
export * from "./LookupColumnFiltersView.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\repos\\Platform\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__